import React, { useState, useEffect } from 'react'
import {
    withStyles
} from "@material-ui/core/styles"
import Tooltip from '@material-ui/core/Tooltip'
import Api from '../../../pages/api/api'

const CustomTooltip = withStyles({
    tooltip: {
        color: "black",
        backgroundColor: "white",
        boxShadow: "0 20px 80px 2px rgba(77, 72, 103, 0.1)",
        border: "solid 1px gray",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "13px"
    }
})(Tooltip)


export default function AppMaker(props) {
  
    const mapHandler = (data, index) => {
        return (
            <div key={index}>
                <CustomTooltip enterTouchDelay={0} title={data}>
                    <img style={{ width: "22px", height: "22px", marginInlineStart: "10px" }} src={`/assets/icons/${data}.png`} alt="Icon" />
                </CustomTooltip>

            </div>
        )
    }


    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            {
                (props.info.app_maker !== undefined && props.info.app_maker !== 0) ?
                    props.info.app_maker.map(mapHandler)
                    :
                    "-"
            }
        </div>
    )
}